import {
  Button,
  Col,
  Descriptions,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Switch,
  Table,
  Tag,
} from 'antd';
import {EditTwoTone, InfoCircleOutlined, PlusOutlined, ThunderboltFilled} from '@ant-design/icons';
import {ColumnsType, TablePaginationConfig} from 'antd/lib/table';
import {useEffect, useState} from 'react';
import {
  debounceDelay,
  sortbyFilter,
  statusFilter,
  statusFilterOptions,
} from '../../common/constants';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import {ADD_CUSTOMER, CUSTOMER_DATA, UPDATE_CUSTOMER} from './customers.types';

import {
  addCustomer,
  customerBattery,
  customersList,
  customersStatusFilter,
  getCustomerPlan,
  getPlans,
  pageNumberChange,
  pageSizeChange,
  searchBy,
  sortBy,
  updateCustomer,
  updateCustomerPlan,
} from './customersSlice';
import checkFormUpdate from '../../utils/checkFormUpdate';
import {formatDate} from '../../utils/formatDate';
import {vehiclesList} from '../setup/Vehicle/vehicleSlice';
import {debounce} from 'lodash';
import rupeeIcon from '../../assets/rupee.png';

const Customer = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.customers);
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isUpdateModal, setIsUpdateModal] = useState(false);
  const [customerForm] = Form.useForm();
  const [updatePlanForm] = Form.useForm();
  const [modalData, setModalData] = useState<CUSTOMER_DATA>({} as CUSTOMER_DATA);
  const [customerBatteryModal, setIsCustomerBatteryModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const vehicleModelOptions = useAppSelector((state) => state.vehicles.vehicles.pageData);
  const userPermission = useAppSelector((state) => state.config.config);

  useEffect(() => {
    dispatch(
      customersList({
        page_size: state.customers.page_size,
        page_number: state.customers.page_number,
        sort_by: state.customers.sort_by,
        ascending: state.customers.ascending,
        search: state.customers.search,
        is_active: state.customers.is_active,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.customers.page_number,
    state.customers.page_size,
    state.customers.search,
    state.customers.is_active,
    state.customers.ascending,
    state.customers.sort_by,
  ]);

  const handleUpdateCustomer = (values: UPDATE_CUSTOMER) => {
    const pass = values.password;
    delete values.password;
    const payload = checkFormUpdate(values, modalData);
    if (pass !== undefined && pass?.length) {
      payload.password = pass;
    }
    if (Object.keys(payload).length > 0) {
      dispatch(updateCustomer({payload: payload, id: modalData.id}))
        .unwrap()
        .then(() => {
          handleCustomerModalClose();
          dispatch(
            customersList({
              page_size: state.customers.page_size,
              page_number: state.customers.page_number,
              sort_by: state.customers.sort_by,
              ascending: state.customers.ascending,
              search: state.customers.search,
              is_active: state.customers.is_active,
            }),
          );
        });
    } else {
      message.warning('No fields are updated');
    }
  };

  const handleAddCustomer = (values: ADD_CUSTOMER) => {
    dispatch(addCustomer(values))
      .unwrap()
      .then(() => {
        handleCustomerModalClose();
        dispatch(
          customersList({
            page_size: state.customers.page_size,
            page_number: state.customers.page_number,
            sort_by: state.customers.sort_by,
            ascending: state.customers.ascending,
            search: state.customers.search,
          }),
        );
      });
  };

  const handleCustomerModalClose = () => {
    customerForm.resetFields();
    setIsCustomerModalOpen(false);
  };

  const handleUpdatePlan = (x: any) => {
    const payload: any = {customer_id: modalData.id};
    const foundObject = state.plans.find((obj) => obj.name === x.plan);
    payload['paymentObject'] = foundObject;
    // console.log(payload);
    dispatch(updateCustomerPlan(payload));
  };

  const handleVehicleModalBouncing = debounce((newValue) => {
    dispatch(vehiclesList({search: newValue, is_active: true}));
  }, debounceDelay);

  const columns: ColumnsType<CUSTOMER_DATA> = [
    {
      title: 'S. No.',
      width: 70,
      render: (test, record, index) => {
        return <>{(state.customers.page_number - 1) * state.customers.page_size + index + 1}</>;
      },
    },
    {
      title: 'Full Name',
      dataIndex: 'name',
      sorter: true,
    },
    {
      title: 'User Name',
      dataIndex: 'username',
      sorter: true,
    },
    {
      title: ' Email',
      dataIndex: 'email',
      sorter: true,
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      render: (_, record) => {
        return record.is_active === true ? (
          <Tag color='green'>Active</Tag>
        ) : (
          <Tag color='red'>Inactive</Tag>
        );
      },
    },

    {
      title: 'Actions',
      key: 'operation',
      render: (_, record) => {
        return (
          <>
            <InfoCircleOutlined
              style={{cursor: 'pointer', fontSize: '16px', color: 'green', marginInline: '10px'}}
              onClick={() => {
                setModalData(record);
                setIsInfoModalOpen(true);
              }}
            />
            {userPermission.permissions.update_customer && (
              <EditTwoTone
                style={{cursor: 'pointer', fontSize: '16px', color: 'blue', marginInline: '10px'}}
                onClick={() => {
                  setModalData(record);
                  dispatch(vehiclesList({is_active: true}));
                  setIsUpdateModal(true);
                  customerForm.setFieldsValue({
                    name: record.name,
                    email: record.email,
                    phone: record.phone,
                    is_active: record?.is_active,
                    password: undefined,
                    vehicle_model_id: record.vehicle_model_id,
                  });
                  setIsCustomerModalOpen(true);
                }}
              />
            )}
            <ThunderboltFilled
              onClick={() => {
                dispatch(customerBattery(record.id))
                  .unwrap()
                  .then(() => {
                    setIsCustomerBatteryModal(true);
                  });
              }}
              style={{cursor: 'pointer', fontSize: '16px', color: 'green', marginInline: '10px'}}
            ></ThunderboltFilled>
            <span
              role='img'
              aria-label='thunderbolt'
              style={{cursor: 'pointer', fontSize: '16px', marginInline: '10px'}}
              className='anticon anticon-thunderbolt'
              onClick={() => {
                setModalData(record);
                dispatch(getPlans());
                dispatch(getCustomerPlan(record.id))
                  .unwrap()
                  .then((x) => {
                    updatePlanForm.setFieldsValue({plan: x.data.plan_name});
                  });
                setPaymentModal(true);
              }}
            >
              <img src={rupeeIcon} alt='payment' style={{width: '15px'}} />
            </span>
          </>
        );
      },
    },
  ];

  const customerColumns: ColumnsType<{id: number; asset_id: string; name: string}> = [
    {
      title: 'S. No.',
      width: 70,
      render: (test, record, index) => {
        return <>{index + 1}</>;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Asset_id',
      dataIndex: 'asset_id',
    },
  ];

  const handleSearch = (e: string) => {
    if (e.length > 3) {
      dispatch(searchBy(e));
    } else if (e.length === 0) {
      dispatch(searchBy(e));
    }
  };
  return (
    <div>
      <div
        style={{
          margin: '10px 0px 10px 0px',
          width: '100%',
          display: 'grid',
          gridTemplateColumns: '350px  1fr   1fr',
        }}
      >
        <Input.Search
          placeholder='Search'
          defaultValue={state.customers.search}
          style={{borderRadius: '10px'}}
          allowClear
          onSearch={(e) => handleSearch(e)}
        />
        <Select
          style={{width: '100px', marginLeft: '5px'}}
          value={
            state.customers.is_active === undefined
              ? statusFilter.ALL
              : state.customers.is_active === true
              ? statusFilter.ACTIVE
              : statusFilter.INACTIVE
          }
          options={statusFilterOptions}
          onChange={(value) => {
            if (value === statusFilter.ACTIVE) {
              dispatch(customersStatusFilter(true));
            } else if (value === statusFilter.INACTIVE) {
              dispatch(customersStatusFilter(false));
            } else {
              dispatch(customersStatusFilter(undefined));
            }
          }}
          showArrow
        />
        <div style={{width: '100%', textAlign: 'end'}}>
          {userPermission.permissions.add_customer && (
            <Button
              type='primary'
              icon={<PlusOutlined />}
              style={{borderRadius: '5px', marginInline: '5px'}}
              onClick={() => {
                setIsUpdateModal(false);
                dispatch(vehiclesList({is_active: true}));
                setIsCustomerModalOpen(true);
              }}
            >
              Add Customer
            </Button>
          )}
        </div>
      </div>
      <Table
        rowKey='id'
        columns={columns}
        pagination={
          {
            total: state.customers.totalDataCount,
            current: state.customers.page_number,
            pageSize: state.customers.page_size,
            showSizeChanger: true,
            // onChange: (pageNumber, pageSize) => {
            //   if (pageSize !== state.customers.page_size) {
            //     dispatch(pageSizeChange({pageNumber, pageSize}));
            //   } else {
            //     dispatch(pageNumberChange(pageNumber));
            //   }
            // },
          } as TablePaginationConfig
        }
        loading={state.isLoading}
        size='middle'
        dataSource={state.customers.pageData}
        scroll={{x: undefined, y: '69vh'}}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={(pagination, _, {order, field}: any) => {
          if (pagination.pageSize && pagination.pageSize !== state.customers.page_size) {
            dispatch(pageSizeChange(pagination.pageSize));
          }
          if (pagination.current && pagination.current !== state.customers.page_number) {
            dispatch(pageNumberChange(pagination.current));
          }
          if (field) {
            if (order === sortbyFilter.DESCEND) {
              dispatch(sortBy({ascending: false, sortBy: field}));
            } else {
              dispatch(sortBy({ascending: true, sortBy: field}));
            }
          }
        }}
      />
      {isInfoModalOpen && (
        <Modal
          title={`${modalData.name}`}
          open={isInfoModalOpen}
          onCancel={() => {
            setIsInfoModalOpen(false);
          }}
          footer={null}
          width={800}
        >
          <Descriptions bordered column={2}>
            <Descriptions.Item label='Customer Name' labelStyle={{fontWeight: 'bolder'}}>
              {modalData.name}
            </Descriptions.Item>
            <Descriptions.Item label='User Name' labelStyle={{fontWeight: 'bolder'}}>
              {modalData.username}
            </Descriptions.Item>
            <Descriptions.Item label='Email' labelStyle={{fontWeight: 'bolder'}}>
              {modalData.email}
            </Descriptions.Item>
            <Descriptions.Item label='Phone' labelStyle={{fontWeight: 'bolder'}}>
              {modalData.phone}
            </Descriptions.Item>
            <Descriptions.Item label='Status' labelStyle={{fontWeight: 'bolder'}}>
              {modalData.is_active ? (
                <Tag color='green'>Active</Tag>
              ) : (
                <Tag color='red'>Inactive</Tag>
              )}
            </Descriptions.Item>
            <Descriptions.Item label='Vehicle Modal' labelStyle={{fontWeight: 'bolder'}}>
              {modalData.vehicle_model_name}
            </Descriptions.Item>
            <Descriptions.Item label='Created By' labelStyle={{fontWeight: 'bolder'}}>
              {modalData.created_by}
            </Descriptions.Item>
            <Descriptions.Item label='Created At' labelStyle={{fontWeight: 'bolder'}}>
              {formatDate(modalData.created_at)}
            </Descriptions.Item>
            <Descriptions.Item label='Updated By' labelStyle={{fontWeight: 'bolder'}}>
              {modalData.updated_by}
            </Descriptions.Item>
            <Descriptions.Item label='Updated At' labelStyle={{fontWeight: 'bolder'}}>
              {formatDate(modalData.updated_at)}
            </Descriptions.Item>
            <Descriptions.Item label='Last Login ' labelStyle={{fontWeight: 'bolder'}}>
              {formatDate(modalData.last_login_at)}
            </Descriptions.Item>
          </Descriptions>
        </Modal>
      )}
      {isCustomerModalOpen && (
        <Modal
          title={isUpdateModal ? 'Update Customer' : 'Add Customer'}
          open={isCustomerModalOpen}
          maskClosable={false}
          onCancel={() => {
            handleCustomerModalClose();
          }}
          okText={isUpdateModal ? 'Update ' : 'Add'}
          confirmLoading={state.isLoading}
          onOk={() => {
            customerForm
              .validateFields()
              .then((values) => {
                {
                  isUpdateModal ? handleUpdateCustomer(values) : handleAddCustomer(values);
                }
              })
              .catch((info) => {
                console.error('Validate Failed:', info);
              });
          }}
        >
          <Row>
            <Col span={24}>
              <Form
                name='updateUser'
                form={customerForm}
                labelCol={{span: 8}}
                wrapperCol={{span: 14}}
                layout='horizontal'
              >
                <Form.Item
                  name='name'
                  label='Full Name'
                  rules={[
                    {
                      required: true,
                      message: 'Please fill your Username ',
                    },
                    {min: 4, max: 16, message: ' Usename should be between 4-16 characters'},
                  ]}
                >
                  <Input autoComplete='off' placeholder='Full Name' />
                </Form.Item>
                {!isUpdateModal && (
                  <Form.Item
                    name='username'
                    label=' User Name'
                    rules={[
                      {
                        required: true,
                        message: 'Please fill your Username ',
                      },
                      {min: 4, max: 16, message: ' Usename should be between 4-16 characters'},
                    ]}
                  >
                    <Input autoComplete='off' placeholder='Username' />
                  </Form.Item>
                )}
                <Form.Item
                  name='password'
                  label='Password'
                  rules={[
                    {
                      min: 4,
                      max: 16,
                      required: isUpdateModal ? false : true,
                      message: 'Password must be between 8 to 16 characters',
                    },
                  ]}
                >
                  <Input.Password autoComplete='off' placeholder='Password' />
                </Form.Item>

                <Form.Item
                  name='email'
                  label='Email'
                  rules={[
                    {
                      type: 'email',
                      required: true,
                      message: 'Please fill a valid email',
                    },
                  ]}
                >
                  <Input autoComplete='off' placeholder='Email' />
                </Form.Item>
                <Form.Item
                  name='phone'
                  label='Phone'
                  rules={[
                    {
                      pattern: new RegExp('^[0-9]{10}$'),
                      required: true,
                      message: 'Enter a valid 10 digit number',
                    },
                  ]}
                >
                  <Input autoComplete='off' placeholder='Phone' />
                </Form.Item>
                <Form.Item
                  label='Select Vehicle Model'
                  name='vehicle_model_id'
                  rules={[{required: true, message: 'Please select a vehicle'}]}
                >
                  <Select
                    showSearch
                    placeholder='Search Vehicle Model'
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    filterOption={false}
                    onSearch={(e) => {
                      if (e.length > 3) handleVehicleModalBouncing(e);
                    }}
                    notFoundContent={null}
                  >
                    {vehicleModelOptions.map((x) => (
                      <Select.Option key={x.id} value={x.id}>
                        {x.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                {isUpdateModal && (
                  <Form.Item name='is_active' label='Status' valuePropName='checked'>
                    <Switch checkedChildren='Active' unCheckedChildren='Inactive' />
                  </Form.Item>
                )}
              </Form>
            </Col>
          </Row>
        </Modal>
      )}
      {customerBatteryModal && (
        <Modal
          title='Customer batteries'
          open={customerBatteryModal}
          maskClosable={false}
          footer={null}
          onCancel={() => {
            setIsCustomerBatteryModal(false);
          }}
        >
          <Row>
            <Col span={24}>
              {state.customerBattery.length === 0 ? (
                <h3> No Battery Assigned</h3>
              ) : (
                <Table
                  rowKey='id'
                  columns={customerColumns}
                  size='middle'
                  dataSource={state.customerBattery}
                  pagination={false}
                />
              )}
            </Col>
          </Row>
        </Modal>
      )}
      {paymentModal && (
        <Modal
          title='Customer Plan'
          open={paymentModal}
          maskClosable={false}
          footer={null}
          onCancel={() => {
            updatePlanForm.resetFields();
            setPaymentModal(false);
          }}
        >
          <Row>
            <Col span={24}>
              <Form
                name='updatePlanForm'
                form={updatePlanForm}
                labelCol={{span: 24}}
                wrapperCol={{span: 24}}
                layout='horizontal'
                onFinish={handleUpdatePlan}
              >
                <Form.Item
                  name='plan'
                  label='Payment Plan'
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    placeholder=' Select Plan'
                    defaultActiveFirstOption={false}
                    disabled={Object.keys(state.customerPlan).length < 1 ? false : true}
                    showArrow={false}
                    filterOption={false}
                    notFoundContent={null}
                    style={{width: '100%'}}
                  >
                    {state.plans.map((x) => {
                      return (
                        <Select.Option key={x.name} value={x.name}>
                          {x.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Button type='primary' htmlType='submit' style={{marginTop: '30px'}}>
                  Update Plan
                </Button>
              </Form>
            </Col>
          </Row>
        </Modal>
      )}
    </div>
  );
};

export default Customer;
